export const changeTrainStart = (state,obj)=>{
    state.trainStart = obj.result;
}

export const changeTrainResult = (state,obj)=>{
    state.trainResult = obj.result;
}


// WEBPACK FOOTER //
// ./src/store/mutations.js